import { UpdateFeatureDefinition, UpdateFeatureRuleTypeDefinition } from 'application-types';

import Types from '../../../properties/Types';

if (!Types.isType(UpdateFeatureRuleTypeDefinition.name)) {
  Types.addType(UpdateFeatureRuleTypeDefinition);
}

export { UpdateFeatureDefinition };
